import type { ModuleVisibilityRepository } from '../../application/ModuleVisibilityRepository'
import type { AppModuleSetting } from '../../domain/moduleVisibility'

const defaultModules: { moduleKey: string; label: string; isActive?: boolean }[] = [
  { moduleKey: 'vue_ensemble', label: 'Vue d’ensemble' },
  { moduleKey: 'vue_ensemble_1', label: 'Vue d’ensemble-1', isActive: false },
  { moduleKey: 'vue_ensemble_2', label: 'Vue d’ensemble-2' },
  { moduleKey: 'centre_operations', label: 'Centre des opérations' },
  { moduleKey: 'centre_operations_2', label: 'Centre des opérations 2', isActive: false },
  { moduleKey: 'soumissions', label: 'Demandes' },
  { moduleKey: 'demandes_v3', label: 'Demandes-V3' },
  { moduleKey: 'clients', label: 'Clients' },
  { moduleKey: 'contrats', label: 'Contrats' },
  { moduleKey: 'renouvellements', label: 'Renouvellements' },
  { moduleKey: 'routes', label: 'Routes' },
  { moduleKey: 'secteurs', label: 'Secteurs' },
  { moduleKey: 'missions', label: 'Missions' },
  { moduleKey: 'employes', label: 'Employés' },
  { moduleKey: 'equipements', label: 'Équipements' },
  { moduleKey: 'facturation', label: 'Facturation' },
  { moduleKey: 'commentaires', label: 'Commentaires' },
  { moduleKey: 'courriels', label: 'Courriels' },
  { moduleKey: 'qualite_saison', label: 'Qualité saison' },
]

export function createFixtureModuleVisibilityRepository(
  source: 'fixtures' | 'fixture-fallback' = 'fixtures',
): ModuleVisibilityRepository {
  const modules: AppModuleSetting[] = defaultModules.map(({ isActive, ...module }) => ({
    ...module,
    isActive: isActive ?? true,
    updatedAt: new Date().toISOString(),
  }))
  return {
    listModules() {
      return Promise.resolve({
        modules: modules.map((module) => ({ ...module })),
        meta: { source, retrievedAt: new Date().toISOString() },
      })
    },
    setModuleActive(command) {
      const module = modules.find((candidate) => candidate.moduleKey === command.moduleKey)
      if (!module) return Promise.reject(new Error('APP_MODULE_SETTINGS_NOT_FOUND'))
      module.isActive = command.isActive
      module.updatedAt = new Date().toISOString()
      return Promise.resolve()
    },
  }
}
